/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable @nx/enforce-module-boundaries */
import Head from 'next/head';
import { AllSearchListing } from 'v4/snippets/search/all';
import { SearchLayout } from 'v4/snippets/search/layout';
import { useSelector } from 'react-redux';
import { useContext } from 'react';
import { SearchContext } from 'v4/snippets/search/context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useBranchPageview } from 'v4/lib/hooks/use-branch-pageview';
import { Spinner, HStack, Box } from '@mybridge/ui';
export default ({ ...props }) => {
  const { loggedIn } = useSelector((state) => state.user);
  const { globalNotifCount } = useSelector((state) => state.notifications);
  const { query } = useContext(SearchContext);
  const { t } = useTranslator();
  const { isBranchLoading } = useBranchPageview();

  const titleParts = [];
  if (loggedIn && globalNotifCount) {
    titleParts.push(`(${globalNotifCount})`);
  }
  if (query?.query) {
    titleParts.push(`${query.query} -`);
  }
  titleParts.push(t('searchPage.searchResults') || "Search results");
  titleParts.push("myBridge.me");
  const pageTitle = titleParts.join(' ');

  return (
    <>
      <SearchLayout activeTab={'all'}>
        <Head>
          <title>{pageTitle}</title>
          <link
            rel="canonical"
            href={`${typeof window !== 'undefined' && window.location.href}`}
          />
        </Head>
        {isBranchLoading ? (
          <Box w="100%" minH="50vh" display="flex" alignItems="center" justifyContent="center">
            <HStack spacing={4}>
              <Spinner size="lg" />
            </HStack>
          </Box>
        ) : (
          <AllSearchListing />
        )}
      </SearchLayout>
    </>
  );
};
